export default __webpack_public_path__ + "static/media/Cloud-EN.e4455851.jpg";